import React from 'react'
import Dropdown from '../../components/Generic/Dropdown'
import { globe, ellips } from '../../assets'
import { Button } from '../../components/Generic'


const Language = () => {
  return (
    <div className='flex flex-col   max-w-[428px] sm:w-[387px] w-full justify-center items-center'>
      <img className="absolute top-[30%] left-[15%] z-0 md:left-[42%]" src={ellips} alt="" />
        <img className='w-[50px] mt-[70px] h-[50px]' src={globe} alt="" />
        <div className='text-gray-darkGray font-sans mt-[15px] mb-[145px]'>Language</div>
        <Dropdown optionss={['English', 'Uzbek', 'Russian']} defaultOption={'Choose language'}/>
        <Button style={`w-[428px] mt-[186px]`} link={'/login'} value={'Next'}/>
    </div>
  )
}

export default Language